import SimpleChart from './core/Chart.js';

export default SimpleChart;
export { SimpleChart };
